import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar29Colors = {
  background?: string;
  skin?: string;
  hair?: string;
  accessories?: string;
};

export const Avatar29 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar29Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar29" clipPath="url(#clip0_2286_5415)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M199.904 168.008c6.578 2.357 15.259-5.081 19.376-16.605 4.126-11.524 2.135-22.769-4.444-25.126-2.564-.916-4.762-1.123-6.681-.749.016-.788.032-1.569.032-2.341 0-47.625-6.738-80.11-74.066-80.11-37.287 0-41.81 51.4-40.114 94.023 0 15.721-1.816 15.291.048 28.575 13.339 39.652 26.759 55.437 37.104 55.572a61.815 61.815 0 0 0 4.508-.103c2.333 12.862 3.83 27.802 1.114 31.362-1.64 2.15-7.518 6.698-14.844 11.938l-7.773 34.516a152.106 152.106 0 0 0 37.661 4.715c12.998 0 25.852-1.665 37.989-4.795l29.259-50.085c-5.646-4.85-10.863-10.107-14.295-15.259-11.094-16.661-11.739-36.252-12.026-53.192a123.353 123.353 0 0 0 6.133-12.79c.326.175.661.335 1.011.454h.008Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M175.056 230.525c-14.025 12.703-27.731 16.566-36.778 17.569.168-7.446-2.126-18.126-2.62-27.046 37.463-8.203 52.507-35.869 57.07-42.973 0 .47 1.704 34.906-17.664 52.443l-.008.007Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_2"
          d="m114.172 298.952 7.772-34.516c-12.232 8.752-28.51 19.464-35.893 24.274a151.215 151.215 0 0 0 28.113 10.242h.008Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          d="m219.081 248.787-29.26 50.086c21.638-5.575 41.397-15.801 58.169-29.547-2.373-1.401-16.645-10.003-28.917-20.539h.008Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M115.884 121.793c13.825 14.813-.693 39.541 4.691 44.049 3.759 3.146 17.974-1.251 18.532 2.771-5.177 3.385-23.494 4.428-23.749-1.736-1.688-4.038 12.408-27.707-4.714-43.228 2.102 1.545 5.59-1.06 5.232-1.856h.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_5"
          d="M93.752 117.819c-.04 2.604-.048 5.208-.024 7.797 12.448.207 22.379 5.025 23.621 1.489.853-2.421.032-11.357-23.597-9.286Z"
          fill="#000"
        />
        <Path
          id="Vector_6"
          d="M180.034 120.145c.422.302.143.971-.367.86-4.085-.845-12.957-2.469-20.308-2.326-11.635.231-19.209 9.398-22.116 3.353-1.967-4.086-.255-9.716 21.113-9.716 9.094 0 14.168 2.461 21.686 7.821l-.008.008Z"
          fill="#000"
        />
        <Path
          id="Vector_7"
          d="M175.168 131.581c-1.895 0-5.686-4.332-15.832-4.332s-16.78 12.041-16.78 12.041 4.698-2.851 9.748-4.89a6.87 6.87 0 0 0-.072.996 7.32 7.32 0 0 0 14.638 0c0-.574-.08-1.123-.199-1.657 3.153 1.211 5.726 2.7 8.099 2.023 3.791-1.083 4.062-5.686 4.062-5.686s-1.76 1.489-3.656 1.489l-.008.016Z"
          fill="#000"
        />
        <Path
          id="hair"
          d="M268.793 199.761c-3.544-14.184-16.55-18.517-22.459-32.31-5.909-13.786 8.275-18.126 5.121-36.244-3.154-18.126-17.616-26.297-23.024-36.388-10.258-19.13-4.547-19.95-16.764-40.043-12.217-20.093-43.34-15.76-43.34-15.76s-5.846-12.241-36.993-7.79c-44.375 6.34-50.707 42.807-56.918 55.406-6.212 12.591-17.386 18.445-22.53 36.897-5.145 18.445 4.786 25.015 4.97 36.364.174 11.349-17.203 16.143-17.562 36.005-.358 19.87 17.203 27.85 17.736 35.296.534 7.447-11.173 12.066-11.882 19.512-.709 7.446 3.902 12.774 7.63 15.968.47.398.836.788 1.122 1.171A151.944 151.944 0 0 0 86.06 288.71c11.803-7.693 46.358-30.47 50.731-36.212 2.715-3.56 1.218-18.5-1.115-31.362a61.612 61.612 0 0 1-4.508.103c-10.345-.143-23.773-15.92-37.104-55.572-1.864-13.284-.048-12.854-.048-28.575a349.232 349.232 0 0 1-.295-14.534l.98-.757c3.862-2.986 8.466-7.43 8.466-11.659 0-5.065 6.259-40.95 31.505-42.177a37.27 37.27 0 0 1 1.864-.048c16.095 0 21.678 10.616 26.599 19.974 2.453 4.666 4.572 8.696 7.749 10.966 2.891 2.063 6.196 3.854 9.39 5.583 6.69 3.623 13.005 7.04 13.005 11.723 0 1.123 0 4.189 7.661 14.725 3.178-4.683 7.359-6.968 13.906-4.619 6.578 2.357 8.569 13.602 4.443 25.126-4.125 11.524-12.798 18.955-19.376 16.605a7.241 7.241 0 0 1-1.011-.462 122.652 122.652 0 0 1-6.125 12.798c.287 16.932.932 36.523 12.026 53.184 10.887 16.342 39.716 33.727 43.213 35.798a152.243 152.243 0 0 0 18.691-18.19c-2.612-5.702-6.61-14.47-9.326-20.642-4.332-9.852 14.972-16.55 11.429-30.733l-.016.008Z"
          fill={c.hair}
        />
        <Path
          id="Vector_8"
          d="M117.366 137.522c-.63-.51-1.235-1.027-1.816-1.521-3.361-2.851-6.531-5.535-11.699-5.248-.685.039-1.362.119-2.015.215-3.154.27-8.466 3.751-9.573 4.674-1.107.924-.804 2.143-.16 3.019a1.807 1.807 0 0 0 2.518.406c.215-.151 3.735-2.564 6.41-4.269a6.903 6.903 0 0 0 6.563 9.047 6.89 6.89 0 0 0 6.785-5.694c.478.406.972.82 1.481 1.234a1.192 1.192 0 0 0 1.689-.175 1.201 1.201 0 0 0-.175-1.688h-.008Z"
          fill="#000"
        />
        <Path
          id="accessories"
          d="M190.395 183.673c0 12.607 7.287 22.825 16.27 22.825s16.27-10.218 16.27-22.825-7.287-22.824-16.27-22.824-16.27 10.217-16.27 22.824Zm7.398.837c0-6.523 3.767-11.811 8.418-11.811s8.418 5.288 8.418 11.811c0 6.522-3.767 11.81-8.418 11.81s-8.418-5.288-8.418-11.81Z"
          fill={c.accessories}
        />
        <Path
          id="accessories_2"
          d="M106.327 202.5c-6.435 0-11.644-5.814-11.644-12.989 0-4.094 1.705-7.741 4.357-10.122a297.513 297.513 0 0 1-4.58-12.552c-6.737 4.341-11.269 12.448-11.269 21.75 0 13.865 10.075 25.11 22.507 25.11 3.631 0 7.064-.963 10.098-2.667-1.999-2.517-4.038-5.535-6.108-9.079a10.529 10.529 0 0 1-3.361.557v-.008Z"
          fill={c.accessories}
        />
        <Path
          id="Vector_9"
          d="M143.822 181.332c-3.457-.494-6.81-2.461-10.481-2.461-3.671 0-6.698 2.158-6.698 2.158s-2.485-1.768-5.941-1.768-8.211 5.408-8.211 5.408c.295.605 4.412 12.519 15.665 12.519 13.213 0 24.386-15.139 25.198-15.976 0 0-6.036.614-9.532.12Zm-17.434 9.461c-5.813 0-10.154-3.695-13.387-5.001 3.233 1.027 7.088 1.075 12.917 1.075 11.309 0 18.557-1.418 22.69-3.241.103-.048.191.071.103.127-4.061 2.612-10.982 7.04-22.315 7.04h-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5415">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
